import React, { useEffect, useRef, useState } from "react";

import {
  StyleSheet,
  Text,
  View,
  TouchableOpacity,
  Dimensions,
  Image,
  TextInput,
  Alert,
  Button,
} from "react-native";
import { addImage } from "../utils";
import { apiservice } from "../service/api";
import { useRecoilState, useRecoilValue } from "recoil";
import { tokenState, univer, userState } from "../reducer";
import moment from "moment";
const { width, height } = Dimensions.get("window");

const homeProfile = ({ setpages, body }) => {
  const token = useRecoilValue(tokenState);
  const [users, setUser] = useRecoilState(userState);
  const university = useRecoilValue(univer);
  const [data, setdata] = useState([]);
  const [data1, setData1] = useState(body);

  async function getallUniversity() {
    const res = await apiservice({
      path: "/group/getall?university_id=" + users.university_id,
      method: "get",
    });
    if (res.status == 200) {
      setdata(res.data.result);

      console.log("USER", res.data.result);
    }
  }

  async function save() {
    const res = await apiservice({
      path: "/authen/updateinfo",
      method: "put",
      body: data1
    });
    if (res.status == 200) {
      alert('Save complete')
    }
  }

  async function getallUniversity1() {
    const res = await apiservice({
      path: "/authen/allinfo?university_id=" + university.id,
      method: "get",
    });
    console.log();
    if (res.status == 200) {
      console.log(res.data);
      const User = res.data.data.filter((item) => {
        return item.id == body.id;
      });

      setData1(User[0]);
      console.log("User", User[0]);
    }
  }

  useEffect(() => {
    getallUniversity();
    getallUniversity1();
  }, []);

  if (data.length == 0) {
    return null;
  }
  const a = data.filter((val) => val.id == data1?.group_id)[0]?.name;

  return (
    <View style={styles.container}>
      <View style={{ width: width * 0.82, height: height * 0.9 }}>
        <View
          style={{
            width: width * 0.591,
            height: height * 0.546,
            margin: 100,
            flexDirection: "row",
          }}
        >
          <View style={{ width: width * 0.156, height: height * 0.277 }}>
            <View
              style={{
                width: width * 0.13,
                height: width * 0.13,
                backgroundColor: "#ffff",
                borderRadius: 10,
                borderWidth: 1,
                overflow: "hidden",
                borderColor: "#707070",
                justifyContent: "center",
              }}
            >
              <img
                style={{
                  width: width * 0.13,
                  height: width * 0.13,
                  alignSelf: "center",
                  borderRadius: 10,
                  objectPosition: 'top',
                  objectFit: 'cover'
                }}
                src={data1?.image_url?.[0]}
              />
              <TouchableOpacity
                onPress={async () => {
                  const ree = await addImage();
                  const rea = await apiservice({
                    path: "/authen/updateinfo",
                    method: "put",
                    body: {
                      ...data1,
                      image_url: [ree],
                    },
                  });
                  console.log("rea", rea.data);
                  if (rea.status == 200) {
                    getallUniversity1();
                  }
                }}
                style={{
                  width: 35,
                  height: 35,
                  position: "absolute",
                  right: 0,
                  marginRight: 10,
                  bottom: 0,
                  marginBottom: 10,
                }}
              >
                <Image
                  resizeMode={"cover"}
                  style={{ width: 35, height: 35, alignSelf: "center" }}
                  source={require("../img/iconCamare.png")}
                />
              </TouchableOpacity>
            </View>
          </View>
          <View
            style={{
              width: width * 0.435,
              height: height * 0.277,
              paddingLeft: 30,
            }}
          >
            <View style={{ flexDirection: 'row', alignItems: 'center', marginBottom: 5, justifyContent: 'space-between' }}>
              <Text style={styles.Text25}>ชื่อ : </Text>
              <TextInput
                style={[styles.Text25, { paddingHorizontal: 8, borderWidth: 1, width: '80%', height: 30, borderRadius: 5 }]}
                defaultValue={data1.firstname}
                onChangeText={(text) => setData1({ ...data1, firstname: text })}
              />
            </View>

            <View style={{ flexDirection: 'row', alignItems: 'center', marginBottom: 5, justifyContent: 'space-between' }}>
              <Text style={styles.Text25}>นามสกุล : </Text>
              <TextInput
                style={[styles.Text25, { paddingHorizontal: 8, borderWidth: 1, width: '80%', height: 30, borderRadius: 5 }]}
                defaultValue={data1.lastname}
                onChangeText={(text) => setData1({ ...data1, lastname: text })}
              />
            </View>

            <View style={{ flexDirection: 'row', alignItems: 'center', marginBottom: 5, justifyContent: 'space-between' }}>
              <Text style={styles.Text25}>ชื่อเล่น : </Text>
              <TextInput
                style={[styles.Text25, { paddingHorizontal: 8, borderWidth: 1, width: '80%', height: 30, borderRadius: 5 }]}
                defaultValue={data1.nickname}
                onChangeText={(text) => setData1({ ...data1, nickname: text })}
              />
            </View>

            <View style={{ flexDirection: 'row', alignItems: 'center', marginBottom: 5, justifyContent: 'space-between' }}>
              <Text style={styles.Text25}>กลุ่ม : </Text>
              <TextInput
                disabled
                style={[styles.Text25, { paddingHorizontal: 8, backgroundColor: '#ccc', borderWidth: 1, width: '80%', height: 30, borderRadius: 5 }]}
                defaultValue={data1.type.replace("รุ่นที่", "")}
              />
            </View>

            <View style={{ flexDirection: 'row', alignItems: 'center', marginBottom: 5, justifyContent: 'space-between' }}>
              <Text style={styles.Text25}>กลุ่มย่อย : </Text>
              <TextInput
                disabled
                style={[styles.Text25, { paddingHorizontal: 8, backgroundColor: '#ccc', borderWidth: 1, width: '80%', height: 30, borderRadius: 5 }]}
                defaultValue={data?.find((val) => val.id === data1?.group_id)?.name || ""}
              />
            </View>


            <View style={{ flexDirection: 'row', alignItems: 'center', marginBottom: 5, justifyContent: 'space-between' }}>
              <Text style={styles.Text25}>บทบาท : </Text>
              <TextInput
                style={[styles.Text25, { paddingHorizontal: 8, borderWidth: 1, width: '80%', height: 30, borderRadius: 5 }]}
                defaultValue={data1.position}
                onChangeText={(text) => setData1({ ...data1, position: text })}
              />
            </View>

            <View style={{ flexDirection: 'row', alignItems: 'center', marginBottom: 5, justifyContent: 'space-between' }}>
              <Text style={styles.Text25}>ตำแหน่งงาน : </Text>
              <TextInput
                style={[styles.Text25, { paddingHorizontal: 8, borderWidth: 1, width: '80%', height: 30, borderRadius: 5 }]}
                defaultValue={data1.role}
                onChangeText={(text) => setData1({ ...data1, role: text })}
              />
            </View>

            <View style={{ flexDirection: 'row', alignItems: 'center', marginBottom: 5, justifyContent: 'space-between' }}>
              <Text style={styles.Text25}>วันเกิด : </Text>
              <TextInput
                style={[styles.Text25, { paddingHorizontal: 8, borderWidth: 1, width: '80%', height: 30, borderRadius: 5 }]}
                defaultValue={data1.birthday}
                onChangeText={(text) => setData1({ ...data1, birthday: text })}
              />
            </View>

            <View style={{ flexDirection: 'row', alignItems: 'center', marginBottom: 5, justifyContent: 'space-between' }}>
              <Text style={styles.Text25}>โทรศัพท์ : </Text>
              <TextInput
                disabled
                style={[styles.Text25, { paddingHorizontal: 8, borderWidth: 1, width: '80%', backgroundColor: '#ccc', height: 30, borderRadius: 5 }]}
                defaultValue={data1.tel_number}
                onChangeText={(text) => setData1({ ...data1, tel_number: text })}
                keyboardType="phone-pad"
              />
            </View>

            <View style={{ flexDirection: 'row', alignItems: 'center', marginBottom: 5, justifyContent: 'space-between' }}>
              <Text style={styles.Text25}>E-mail : </Text>
              <TextInput
                style={[styles.Text25, { paddingHorizontal: 8, borderWidth: 1, width: '80%', height: 30, borderRadius: 5 }]}
                defaultValue={data1.email}
                onChangeText={(text) => setData1({ ...data1, email: text })}
                keyboardType="email-address"
              />
            </View>

            <TouchableOpacity
              onPress={save}
              style={{
                width: 100,
                height: 40,
                borderRadius: 5,
                backgroundColor: "rgb(0, 35, 119)",
                marginRight: 20,
              }}
            >
              <Text style={styles.TextButton}>ยืนยัน</Text>
            </TouchableOpacity>

            <View
              style={{
                borderWidth: 0.5,
                borderColor: "#70707050",
                width: width * 0.4,
                marginVertical: 15,
              }}
            ></View>
            <Text style={styles.Text16}>
              สร้างเมื่อวันที่ {moment(data1.createdAt).format("DD/MM/YYYY")}
            </Text>
          </View>
        </View>
      </View>
    </View>
  );
};
const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: "#ffff",
  },
  Text25: { fontSize: 18, fontFamily: "Prompt-Regular" },
  Text16: { fontSize: 16, fontFamily: "Prompt-Regular" },
  TextButton: {
    fontSize: 16,
    color: "#ffff",
    margin: "auto",
    fontFamily: "Prompt-Regular",
  },
});

export default homeProfile;
